import WarehouseSelect from './WarehouseSelect.js'

export default function GenericPanel() {
  return <WarehouseSelect />
}
